import React from 'react'
import {Typography, Accordion, AccordionSummary, AccordionDetails} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {SectionConfig} from './types'
import SectionControls from '../../shared/UI/SectionsControls'
import LoadingWrapper from './LoadingWrapper/LoadingWrapper'
// eslint-disable-next-line import/extensions
import {SectionContainer, HiddenSectionContainer, HiddenSectionTitle} from './Section.styles'

interface SectionProps {
  section: SectionConfig;
  isFirst: boolean;
  isLast: boolean;
  isHidden: boolean;
  isEditMode: boolean;
  onMoveUp: (id: string) => void;
  onMoveDown: (id: string) => void;
  onToggleVisibility: (id: string) => void;
}

function Section({
                   section,
                   isFirst,
                   isLast,
                   isHidden,
                   isEditMode,
                   onMoveUp,
                   onMoveDown,
                   onToggleVisibility
                 }: Readonly<SectionProps>): React.ReactElement {
  if (isEditMode && isHidden) {
    return (
      <SectionContainer editMode={isEditMode}>
        <SectionControls
          isFirst={isFirst}
          isLast={isLast}
          isHidden={isHidden}
          onMoveUp={() => onMoveUp(section.id)}
          onMoveDown={() => onMoveDown(section.id)}
          onToggleVisibility={() => onToggleVisibility(section.id)}
        />
        <HiddenSectionContainer>
          <HiddenSectionTitle variant="body1">
            {section.title} 
            (Hidden)
          </HiddenSectionTitle>
        </HiddenSectionContainer>
      </SectionContainer>
    )
  }

  const sectionContent = (
    <LoadingWrapper isLoading={section.isLoading ?? false}>
      {section.component}
    </LoadingWrapper>
  )

  if (section.isAccordion) {
    return (
      <SectionContainer editMode={isEditMode}>
        {isEditMode && (
          <SectionControls
            isFirst={isFirst}
            isLast={isLast}
            isHidden={isHidden}
            onMoveUp={() => onMoveUp(section.id)}
            onMoveDown={() => onMoveDown(section.id)}
            onToggleVisibility={() => onToggleVisibility(section.id)}
          />
        )}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography sx={{color: 'black', fontSize: '1.0rem'}}>
              {section.title}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {sectionContent}
          </AccordionDetails>
        </Accordion>
      </SectionContainer>
    )
  }

  return (
    <SectionContainer editMode={isEditMode}>
      {isEditMode && (
        <SectionControls
          isFirst={isFirst}
          isLast={isLast}
          isHidden={isHidden}
          onMoveUp={() => onMoveUp(section.id)}
          onMoveDown={() => onMoveDown(section.id)}
          onToggleVisibility={() => onToggleVisibility(section.id)}
        />
      )}
      {sectionContent}
    </SectionContainer>
  )
}

export default Section